import { Component, OnInit, OnDestroy, ViewEncapsulation, Input, OnChanges, SimpleChanges } from '@angular/core';
import { formatNumber } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { switchMap, concatMap, takeUntil } from 'rxjs/operators';
import { from, of } from 'rxjs';

import { environment } from 'src/environments/environment';

import { GraphData } from 'src/app/shared/dashboard';
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service';
import { RestApiService } from 'src/app/services/rest-api.service';

@Component({
  selector: 'app-home-chart-monthly-client-payments',
  templateUrl: './home-chart-monthly-client-payments.component.html',
  styleUrl: './home-chart-monthly-client-payments.component.css',
  encapsulation: ViewEncapsulation.None
})
export class HomeChartMonthlyClientPaymentsComponent implements OnInit, OnDestroy, OnChanges {

  private destroy$ = new Subject<void>();
  private query$ = new Subject<{ CLIID: number, DATETO: Date, CURRID: number, TOP: number }>();

  @Input() top: number = 8;
  @Input() date: Date = new Date();

  dataMonthlyClientsPayments: GraphData = null;
  monthlyClientsOptions: any = null;

  dateValue: Date = new Date();

  constructor(
    private restapi: RestApiService,
    private globalsettingsservice: GetglobalsettingsService,
    private titleService: Title,
  ) { }

  ngOnInit(): void {
    console.log('*** HomeChartMonthlyClientPaymentsComponent ngOnInit');

    this.dateValue = this.date ?? new Date();

    this.monthlyClientsOptions = {
      scales: {
        y: {
          scaleBeginAtZero: true,
          ticks: { beginAtZero: true, min: 0 }
        },
        x: {
          ticks: { color: 'red', align: 'center' }
        }
      },
      tooltips: {
        enabled: true,
        mode: 'label',
        callbacks: {
          label: (tooltipItems: any) => {
            environment.production || console.log('tooltips item: ' + JSON.stringify(tooltipItems));
            return '$' + formatNumber(<number>tooltipItems.yLabel, 'uk', '1.0-0');
          }
        }
      },
    };

    this.query$.pipe(
      takeUntil(this.destroy$),
      switchMap(row => this.restapi.getMonthlyClientsPayments(row.CLIID, row.CURRID, row.TOP, row.DATETO).pipe(

        concatMap(data => {
          this.titleService.setTitle('Платежи - Лучшие покупатели місяця');

          if (!data?.length) { return of(null); }

          this.dataMonthlyClientsPayments = {
            labels: [],
            datasets: [{ label: 'Клієнт', data: [], fill: false, backgroundColor: '#277622' }],
            options: {}
          };

          return from(data);
        }),

        concatMap((element:any) => {
          if (!element) { return of(null); }
          this.dataMonthlyClientsPayments.labels.push(
            element.CLIENTNAME + '(%' + formatNumber(element.MONTHLYPART * 100, 'uk', '1.0-0') + ')'
          );
          this.dataMonthlyClientsPayments.datasets[0].data.push(element.CLIENTVALUE);
          return of(element);
        }),
      ))
    ).subscribe({
      error: err => console.error('*** HomeChartMonthlyClientPaymentsComponent query$ error:', err),
    });

    // Wait for global settings then trigger initial load
    this.globalsettingsservice.getObservableGlobalSettings().pipe(
      takeUntil(this.destroy$),
    ).subscribe({
      next: settings => this.triggerQuery(settings.mainCompanyId, settings.balanceCurrencyId),
      error: err => console.error('*** HomeChartMonthlyClientPaymentsComponent settings error:', err),
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['date'] && !changes['date'].firstChange) {
      this.dateValue = changes['date'].currentValue ?? new Date();
      this.refresh();
    }
  }

  ngOnDestroy(): void {
    console.log('*** HomeChartMonthlyClientPaymentsComponent ngOnDestroy');
    this.destroy$.next();
    this.destroy$.complete();
  }

  onDateSelect(event: any): void {
    this.dateValue = new Date(event);
    this.refresh();
  }

  private triggerQuery(companyId: number, currencyId: number): void {
    this.query$.next({
      CLIID: companyId,
      CURRID: currencyId,
      TOP: this.top,
      DATETO: this.dateValue,
    });
  }

  private refresh(): void {
    const settings = this.globalsettingsservice.getGlobalSettings();
    if (settings) {
      this.triggerQuery(settings.mainCompanyId, settings.balanceCurrencyId);
    }
  }

  selectData(event: any): void { }
}
